import { Table } from "antd";
import { useState } from "react";
import svg2 from "../../../assets/svg/svg2.svg";
import ReconciliationAddModal from "./modal/ReconciliationAddModal";
import BreadCrumb from "../../../layout/BreadCrumb";

export default function ReconciliationTable() {
  const [data, setData] = useState({});
  const [open, setopen] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const handleAdd = () => {
    setopen(true);
  };

  const columns = [
    {
      title: "Receipt No",
      dataIndex: "receiptNo",
      key: "receiptNo",
    },
    {
      title: "Completion Time",
      dataIndex: "completionTime",
      key: "completionTime",
      render: (text) => {
        if (!text) return "-";
        return new Date(text).toLocaleString();
      },
    },
    {
      title: "Withdrawn",
      dataIndex: "withdrawn",
      key: "withdrawn",
      render: (value) => {
        if (value === null || value === undefined) return "-";
        return value < 0 ? `KES ${Math.abs(value).toFixed(2)}` : "-";
      },
    },
    {
      title: "Paid In",
      dataIndex: "paidIn",
      key: "paidIn",
      render: (value) => {
        if (value === null || value === undefined) return "-";
        return `KES ${value.toFixed(2)}`;
      },
    },
    {
      title: "Other Party",
      dataIndex: "otherPartyInfo",
      key: "otherPartyInfo",
    },
    {
      title: "Reason",
      dataIndex: "reasonType",
      key: "reasonType",
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      render: (value) => {
        if (value === null || value === undefined) return "-";
        return `KES ${value.toFixed(2)}`;
      },
    },
    {
      title: "Match Status",
      dataIndex: "matchStatus",
      key: "matchStatus",
      render: (status) => {
        const statusColors = {
          FOUND: "text-green-600 bg-green-100",
          NOT_FOUND: "text-red-600 bg-red-100",
          PENDING: "text-yellow-600 bg-yellow-100",
        };
        const colorClass = statusColors[status] || "text-gray-600 bg-gray-100";
        return (
          <span className={`px-2 py-1 rounded ${colorClass}`}>
            {status || "-"}
          </span>
        );
      },
    },
  ];

  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Home</span>
        </div>
      ),
      href: "/#/home",
    },
    {
      title: <div className="text-lighGold text-[16px]">Reconciliation</div>,
    },
  ];

  return (
    <div className="w-full h-full overflow-y-scroll">
      <div className="justify-between items-center white_card">
        <BreadCrumb
          breadList={breadList}
          header={"Reconciliation"}
          info={"Upload and view reconciliation statements"}
          btn={true}
          btnTitle="Upload Statement"
          onClick={handleAdd}
          btnSvg={svg2}
        />
      </div>

      <div className="flex items-start lg:flex-row flex-col gap-5 w-full mt-[1.25rem]">
        <div className="bg-white rounded-[10px] flex-1 min-w-0 w-full lg:w-1/2 overflow-hidden">
          <div className="flex flex-col w-full lg:px-10 px-3">
            <h3 className="heading_4 mt-[1.25rem]">
              Unmatched Transactions ({data?.unmatchedTransactions?.length || 0}
              )
            </h3>
            <div className="dash-inner-page mt-[24px] mb-5 overflow-x-auto">
              <Table
                rowSelection={false}
                className="w-full"
                scroll={{
                  x: "auto",
                }}
                rowKey={(record, index) =>
                  `${record?.receiptNo}-${index}` || index
                }
                columns={columns}
                dataSource={data?.unmatchedTransactions || []}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  pageSize: 10,
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-[10px] flex-1 min-w-0 w-full lg:w-1/2 overflow-hidden">
          <div className="flex flex-col w-full lg:px-10 px-3">
            <h3 className="heading_4 mt-[1.25rem]">
              Missing in Statement (
              {data?.missingInStatementTransactions?.length || 0})
            </h3>
            <div className="dash-inner-page mt-[24px] mb-5 overflow-x-auto">
              <Table
                rowSelection={false}
                className="w-full"
                scroll={{
                  x: "auto",
                }}
                rowKey={(record, index) =>
                  `${record?.receiptNo}-missing-${index}` || index
                }
                columns={columns}
                dataSource={data?.missingInStatementTransactions || []}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  pageSize: 10,
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <ReconciliationAddModal
        setData={setData}
        open={open}
        handleCancel={handleCancel}
      />
    </div>
  );
}
